import { createNode } from '@glueapp/graph-types';

export const HyperbolicSine = createNode({
    id: 'Hyperbolic Sine',
    name: 'Hyperbolic Sine',
    description: 'Gives the hyperbolic sine of the value',
    aiDescription:
        'Computes the hyperbolic sine of a number. Connect a value to the "Value" input port; the "Result" output port provides the hyperbolic sine.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.sinh(input.inPorts.Value) } };
    },
});
